import { COUNTRY_CODE } from './index';

export default (
  {
    pt: {
      cities: [
        { name: 'Alcácer do Sal', id: 2272212 },
        { name: 'Aveiro', id: 2742611 },
        { name: 'Beja', id: 2270985 },
        { name: 'Braga', id: 2742032 },
        { name: 'Bragança', id: 2742027 },
        { name: 'Caldas da Rainha', id: 2270437 },
        { name: 'Castelo Branco', id: 2269514 },
        { name: 'Chaves', id: 2740761 },
        { name: 'Coimbra', id: 2740637 },
        { name: 'Covilhã', id: 2740313 },
        { name: 'Estremoz', id: 2268411 },
        { name: 'Évora', id: 2268406 },
        { name: 'Faro', id: 2268339 },
        { name: 'Figueira da Foz', id: 2739590 },
        { name: 'Funchal', id: 2267827 },
        { name: 'Guarda', id: 2738784 },
        { name: 'Horta', id: 3372988 },
        { name: 'Leiria', id: 2267095 },
        { name: 'Lisboa', id: 6458923, default: true },
        { name: 'Mirandela', id: 2737639 },
        { name: 'Montijo', id: 2265788 },
        { name: 'Odemira', id: 2265472 },
        { name: 'Ponta Delgada', id: 3372783 },
        { name: 'Portalegre', id: 2264508 },
        { name: 'Portel', id: 2263974 }, //id from Reguengos de Monsaraz
        { name: 'Porto', id: 2735943 },
        { name: 'Porto Santo', id: 8010683 },
        { name: 'Sagres', id: 2263650 },
        { name: 'Santarém', id: 2263480 },
        { name: 'Setúbal', id: 2262963 },
        { name: 'Sines', id: 2262917 },
        { name: 'Tavira', id: 2262744 },
        { name: 'Tomar', id: 2262644 },
        { name: 'Vendas Novas', id: 2261740 },
        { name: 'Viana do Castelo', id: 2732773 },
        { name: 'Vila Nova de Gaia', id: 2732544 },
        { name: 'Vila Real', id: 2732438 },
        { name: 'Viseu', id: 2732265 },
      ],
      units: 'metric',
      lang: 'pt',
    },

    es: {
      cities: [
        { name: 'A Coruña', id: 3119841 },
        { name: 'Alava', id: 3130717 },
        { name: 'Albacete', id: 2522258 },
        { name: 'Alicante', id: 2521978 },
        { name: 'Almería', id: 2521883 },
        { name: 'Asturias', id: 3114710 },
        { name: 'Avila', Id: 3129136 },
        { name: 'Badajoz', id: 2521420 },
        { name: 'Baleares', id: 2521383 },
        { name: 'Barcelona', id: 3128760 },
        { name: 'Burgos', id: 3127461 },
        { name: 'Cáceres', id: 2520611 },
        { name: 'Cádiz', id: 2520600 },
        { name: 'Cantabria', id: 3336898 },
        { name: 'Castellón', id: 2519752 },
        { name: 'Ciudad Real', id: 2519402 },
        { name: 'Córdoba', id: 2519240 },
        { name: 'Cuenca', id: 3124132 },
        { name: 'Gerona', id: 3121456 },
        { name: 'Granada', id: 2517117 },
        { name: 'Guadalajara', id: 3121070 },
        { name: 'Guipúzcoa', id: 3120935 },
        { name: 'Huelva', id: 2516548 },
        { name: 'Huesca', id: 3120514 },
        { name: 'Jaén', id: 2516395 },
        { name: 'La Rioja', id: 3336897 },
        { name: 'Las Palmas', id: 2515270 },
        { name: 'León', id: 3118532 },
        { name: 'Lérida', id: 7874189 },
        { name: 'Lugo', id: 3117814 },
        { name: 'Madrid', id: 3117735, default: true },
        { name: 'Málaga', id: 2514256 },
        { name: 'Murcia', id: 2513416 },
        { name: 'Navarra', id: 3115609 },
        { name: 'Orense', id: 3114965 },
        { name: 'Palencia', id: 3114531 },
        { name: 'Pontevedra', id: 3113209 },
        { name: 'Salamanca', id: 3111108 },
        { name: 'Santa Cruz Tenerife', id: 2511174 },
        { name: 'Segovia', id: 3109256 },
        { name: 'Sevilla', id: 2510911 },
        { name: 'Soria', id: 3108681 },
        { name: 'Tarragona', id: 3108288 },
        { name: 'Teruel', id: 3108126 },
        { name: 'Toledo', id: 2510409 },
        { name: 'Valencia', id: 2509954 },
        { name: 'Valladolid', id: 3106672 },
        { name: 'Viscaya', id: 3128026 },
        { name: 'Zamora', id: 3104342 },
        { name: 'Zaragoza', id: 3104324 },
      ],
      units: 'metric',
      lang: 'es',
    },

    fr: {
      cities: [
        { name: 'Amiens', id: 3037854 },
        { name: 'Bordeaux', id: 3031582 },
        { name: 'Brest', id: 3030300 },
        { name: 'Caen', id: 3029241 },
        { name: 'Calais', id: 3029162 },
        { name: 'Dijon', id: 3021372 },
        { name: 'La Rochelle', id: 3006787 },
        { name: 'Le Mans', id: 3003603 },
        { name: 'Limoges', id: 2998286 },
        { name: 'Lyon', id: 2996944 },
        { name: 'Marseille', id: 2995469 },
        { name: 'Montpellier', id: 2992166 },
        { name: 'Nancy', id: 2990999 },
        { name: 'Nantes', id: 2990969 },
        { name: 'Orléans', id: 2989317 },
        { name: 'Paris', id: 2968815, default: true },
        { name: 'Pau', id: 2988358 },
        { name: 'Poitiers', id: 2986495 },
        { name: 'Reims', id: 2984114 },
        { name: 'Rennes', id: 2983990 },
        { name: 'Rouen', id: 2982652 },
        { name: 'Strasbourg', id: 2973783 },
        { name: 'Toulouse', id: 2972315 },
        { name: 'Tours', id: 2972191 },
        { name: 'Troyes', id: 2971549 },
      ],
      units: 'metric',
      lang: 'fr',
    },

    it: {
      cities: [
        { name: 'Agrigento', id: 2525763 },
        { name: 'Alessandria', id: 3183299 },
        { name: 'Ancona', id: 3183089 },
        { name: 'Andria', id: 3183072 },
        { name: 'Aosta', id: 3182997 },
        { name: 'Arezzo', id: 3182884 },
        { name: 'Ascoli Piceno', id: 3182749 },
        { name: 'Asti', id: 3182714 },
        { name: 'Avellino', id: 3182650 },
        { name: 'Bari', id: 3182350 },
        { name: 'Barletta', id: 3182340 },
        { name: 'Belluno', id: 3182210 },
        { name: 'Benevento', id: 3182179 },
        { name: 'Bergamo', id: 3182164 },
        { name: 'Biella', id: 3182043 },
        { name: 'Bologna', id: 3181927 },
        { name: 'Bolzano', id: 3181912 },
        { name: 'Brescia', id: 3181554 },
        { name: 'Brindisi', id: 3181528 },
        { name: 'Cagliari', id: 2525473 },
        { name: 'Caltanissetta', id: 2525448 },
        { name: 'Campobasso', id: 3180991 },
        { name: 'Carbonia', id: 2525362 },
        { name: 'Caserta', id: 3179866 },
        { name: 'Catania', id: 2525065 },
        { name: 'Catanzaro', id: 2525059 },
        { name: 'Chieti', id: 3178796 },
        { name: 'Como', id: 3178229 },
        { name: 'Cosenza', id: 2524907 },
        { name: 'Cremona', id: 3177838 },
        { name: 'Crotone', id: 2524881 },
        { name: 'Cuneo', id: 3177700 },
        { name: 'Enna', id: 2524818 },
        { name: 'Fermo', id: 3177099 },
        { name: 'Ferrara', id: 3177090 },
        { name: 'Firenze', id: 6542285 },
        { name: 'Foggia', id: 3176885 },
        { name: 'Forlì', id: 3176746 },
        { name: 'Frosinone', id: 3176515 },
        { name: 'Genova', id: 3176217 },
        { name: 'Gorizia', id: 3175986 },
        { name: 'Grosseto', id: 3175786 },
        { name: 'Imperia', id: 3175532 },
        { name: 'Isernia', id: 3175445 },
        { name: "L'Aquila", id: 3175121 },
        { name: 'La Spezia', id: 3175081 },
        { name: 'Latina', id: 3175058 },
        { name: 'Lecce', id: 3174953 },
        { name: 'Lecco', id: 3174945 },
        { name: 'Livorno', id: 3174659 },
        { name: 'Lodi', id: 3174638 },
        { name: 'Lucca', id: 3174530 },
        { name: 'Macerata', id: 3174380 },
        { name: 'Mantova', id: 3174051 },
        { name: 'Massa', id: 3173775 },
        { name: 'Matera', id: 3173721 },
        { name: 'Messina', id: 2524169 },
        { name: 'Milano', id: 3173435 },
        { name: 'Modena', id: 3173331 },
        { name: 'Monza', id: 3172629 },
        { name: 'Napoli', id: 3172391 },
        { name: 'Novara', id: 3172189 },
        { name: 'Nuoro', id: 3172154 },
        { name: 'Oristano', id: 2523964 },
        { name: 'Padova', id: 3171728 },
        { name: 'Palermo', id: 2523918 },
        { name: 'Parma', id: 3171457 },
        { name: 'Pavia', id: 3171366 },
        { name: 'Perugia', id: 3171180 },
        { name: 'Pesaro', id: 3171173 },
        { name: 'Pescara', id: 3171168 },
        { name: 'Piacenza', id: 3171058 },
        { name: 'Pisa', id: 3170647 },
        { name: 'Pistoia', id: 3170621 },
        { name: 'Pordenone', id: 3170147 },
        { name: 'Potenza', id: 3170027 },
        { name: 'Prato', id: 3169911 },
        { name: 'Ragusa', id: 2523649 },
        { name: 'Ravenna', id: 3169561 },
        { name: 'Reggio Calabria', id: 2523630 },
        { name: 'Reggio Emilia', id: 3169524 },
        { name: 'Rieti', id: 3169412 },
        { name: 'Rimini', id: 3169361 },
        { name: 'Roma', id: 3169070, default: true },
        { name: 'Rovigo', id: 3168843 },
        { name: 'Salerno', id: 3168673 },
        { name: 'Sassari', id: 3167096 },
        { name: 'Savona', id: 3167022 },
        { name: 'Siena', id: 3166548 },
        { name: 'Siracusa', id: 2523083 },
        { name: 'Sondrio', id: 3166397 },
        { name: 'Taranto', id: 3165926 },
        { name: 'Teramo', id: 3165803 },
        { name: 'Terni', id: 3165771 },
        { name: 'Torino', id: 3165523 },
        { name: 'Trani', id: 3165322 },
        { name: 'Trapani', id: 2522875 },
        { name: 'Trento', id: 3165243 },
        { name: 'Treviso', id: 3165201 },
        { name: 'Trieste', id: 3165185 },
        { name: 'Udine', id: 3165072 },
        { name: 'Urbino', id: 3165035 },
        { name: 'Varese', id: 3164699 },
        { name: 'Venezia', id: 6542284 },
        { name: 'Verbania', id: 6457398 },
        { name: 'Vercelli', id: 3164565 },
        { name: 'Verona', id: 3164527 },
        { name: 'Vibo Valentia', id: 2522776 },
        { name: 'Vicenza', id: 3164419 },
        { name: 'Viterbo', id: 3164039 },
      ],
      units: 'metric',
      lang: 'it',
    },

    mx: {
      cities: [
        { name: 'Celaya', id: 4014875 },
        { name: 'Ciudad Guzmán', id: 4013714 },
        { name: 'Ciudad Obregón', id: 4013704 },
        { name: 'Culiacán', id: 4012176 },
        { name: 'Ensenada', id: 4006702 },
        { name: 'Guadalajara', id: 4005539, default: true },
        { name: 'Guasave', id: 4005219 },
        { name: 'Hermosillo', id: 4004898 },
        { name: 'Heroica Caborca', id: 4004887 },
        { name: 'Heroica Guaymas', id: 4005143 },
        { name: 'Irapuato', id: 4004330 },
        { name: 'Los Mochis', id: 3997479 },
        { name: 'Los Reyes', id: 3997220 },
        { name: 'Mexicali', id: 3996069 },
        { name: 'Navojoa', id: 3995019 },
        { name: 'Tecomán', id: 3982213 },
        { name: 'Tepic', id: 3981941 },
        { name: 'Zamora', id: 3979802 },
      ],
      units: 'metric',
      lang: 'es',
    },

    br: {
      cities: [
        { name: 'Araraquara', id: 3471766 },
        { name: 'Balsas', id: 3406545 },
        { name: 'Barreiras', id: 3470583 },
        { name: 'Bento Gonçalves', id: 3470073 },
        { name: 'Brasília', id: 3410315, default: true },
        { name: 'Campinas', id: 3467865 },
        { name: 'Campo Grande', id: 3467747 },
        { name: 'Cascavel', id: 3466779 },
        { name: 'Chapecó', id: 3466296 },
        { name: 'Dourados', id: 3464460 },
        { name: 'Franca', id: 3463011 },
        { name: 'Goiânia', id: 3462377 },
        { name: 'Guaxupé', id: 3461763 },
        { name: 'Londrina', id: 3458449 },
        { name: 'Manhuaçu', id: 3457952 },
        { name: 'Palmas', id: 3474574 },
        { name: 'Passo Fundo', id: 3454857 },
        { name: 'Petrolina', id: 3392242 },
        { name: 'Ponta Grossa', id: 3453186 },
        { name: 'Presidente Prudente', id: 3452324 },
        { name: 'Ribeirão Preto', id: 3451328 },
        { name: 'Rio Verde', id: 3451056 },
        { name: 'Rondonópolis', id: 3450909 },
        { name: 'Santa Catarina', id: 3450387 },
        { name: 'São Paulo', id: 3448439 },
        { name: 'Sorriso', id: 3457419 },
        { name: 'Teresópolis', id: 3446606 },
        { name: 'Uberlândia', id: 3445831 },
        { name: 'Varginha', id: 3445487 },
        { name: 'Vitória', id: 3444924 },
      ],
      units: 'metric',
      lang: 'pt_br',
    },

    ro: {
      cities: [
        { name: 'Adjud', id: 686669 },
        { name: 'Alba Iulia', id: 686578 },
        { name: 'Alexandria', id: 686502 },
        { name: 'Arad', id: 686253 },
        { name: 'Bacău', id: 685947 },
        { name: 'Bistriţa', id: 684657 },
        { name: 'Botoşani', id: 684038 },
        { name: 'Brăila', id: 683901 },
        { name: 'Braşov', id: 683843 },
        { name: 'Bucharest', id: 683506, default: true },
        { name: 'Buzău', id: 683121 },
        { name: 'Călăraşi', id: 673150 },
        { name: 'Caracal', id: 682747 },
        { name: 'Cluj', id: 681291 },
        { name: 'Constanța', id: 680962 },
        { name: 'Covasna', id: 680428 },
        { name: 'Craiova', id: 680332 },
        { name: 'Deva', id: 679452 },
        { name: 'Fetești', id: 678303 },
        { name: 'Focșani', id: 678015 },
        { name: 'Galaţi', id: 677697 },
        { name: 'Giurgiu', id: 677104 },
        { name: 'Iaşi', id: 675809 },
        { name: 'Medgidia', id: 673636 },
        { name: 'Olteniţa', id: 671832 },
        { name: 'Oradea', id: 671768 },
        { name: 'Piatra Neamţ', id: 670889 },
        { name: 'Piteşti', id: 670609 },
        { name: 'Ploieşti', id: 670474 },
        { name: 'Râmnicu Sărat', id: 668873 },
        { name: 'Râmnicu Vâlcea', id: 668872 },
        { name: 'Reşiţa', id: 668954 },
        { name: 'Roman', id: 668732 },
        { name: 'Satu Mare', id: 667869 },
        { name: 'Sfântu Gheorghe', id: 667303 },
        { name: 'Sibiu', id: 667267 },
        { name: 'Slobozia', id: 666716 },
        { name: 'Suceava', id: 665849 },
        { name: 'Târgovişte', id: 665024 },
        { name: 'Târgu-Mureş', id: 665004 },
        { name: 'Timişoara', id: 665087 },
        { name: 'Tulcea', id: 664517 },
        { name: 'Urziceni', id: 664073 },
        { name: 'Vaslui', id: 663116 },
      ],
      units: 'metric',
      lang: 'ro',
    },
  } as Record<
    string,
    {
      cities: Array<{ name: string; id: number; default?: true }>;
      units: 'metric';
      lang: 'pt' | 'es' | 'fr' | 'it' | 'pt_br' | 'ro';
    }
  >
)[COUNTRY_CODE] || null;
